import { render, staticRenderFns } from "./SpeciesSummaryTable.vue?vue&type=template&id=3104bd42&"
import script from "./SpeciesSummaryTable.vue?vue&type=script&lang=js&"
export * from "./SpeciesSummaryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports